import MultiCreatable from './MultiCreatable';

export default MultiCreatable;
